import React from 'react'
import { NumericFormat as NumberFormat } from 'react-number-format';

import { withStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const styles = theme => ({
    root: {
        width: '100%',
        backgroundColor: 'white',
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
    },
    selected: {
        backgroundColor: '#90EEA4',
      },
    paper: {
 
    },
    spacerRow: {
        height: 2,
        borderLeft: 0,
        borderRight: 0,
        border: 0,
    },
    table: {
        lineHeight: 0.5,
        marginLeft: '5px',
        marginRight: '5px'
    },
    container2_table: {
        width: '100%',
        alignItems: 'center',
        paddingLeft: '1px',
        paddingRight: '1px',
        borderWidth: 0,
        boxShadow: 'none',
 
    },
    tabletop: {
        lineHeight: 0.5,
    },
    table2: {
        height: 500,
        border: '0px solid white'
    },
    bigfont: {
        fontSize: '24px',
        fontWeight: 'bold'
    },
    yrheadersaving: {
        backgroundColor: '#ff3099',
        color: 'white', 
        fontWeight: '900',
        textAlign: 'center',
        fontSize: '16px',
        borderLeft: '1px solid black',
        borderRight: '1px solid black'

    },
    headerwkwph: {
        width: 100,
    },
    headermoney: {
        width: 100,
    },
    totalRows: {
        fontWeight: 800,
        color: 'black',
    },
    yr1headers: {
 
    },
    borderRow: {
        border: '2px solid #326cd8',
    },
    header30: {
        backgroundColor: '#04c659',
        color: 'white',  
    },
    style30years: {
        fontSize: 14,
        fontWeight: 800,
        textDecoration: 'underline',
        paddingTop: 10,
        paddingBottom: 10,
        border: 0,
    },
    savingsHeaders: {
        backgroundColor: '#04c659',
        color: 'white',
        width: 100,
        fontWeight: 800,
        paddingTop: 2,
        paddingBottom: 2,
    },
    input: {
        fontSize: 12,
        paddingLeft: 5,
    },
    text30: {
        fontSize: 14,
        paddingTop: 2,
        paddingBottom: 2,

    },
    text30_beakeven: {
        fontSize: 14,
        paddingTop: 2,
        paddingBottom: 2,
        backgroundColor: '#90EEA4',

    },
    text_small: {
        fontSize: 12,
        paddingTop: 3,
        paddingBottom: 3,
    },
    yr1pt1: {
      color: '#326cd8',
      fontSize: 16,
      fontWeight: 600,
      textAlign: 'center'
    },
    yr1pt2: {
      color: '#ff3099',
      fontSize: '28px',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    yr1pt3: {
      color: '#326cd8',
      fontSize: 16,
      fontWeight: 600,
      textAlign: 'center'
    },
    mediumFont: {
      color: '#326cd8',
      fontSize: '22px',
      fontWeight: 900,
      textAlign: 'center'
        
    },
    topRows: {
        paddingTop: 2,
        paddingBottom: 2,
        fontWeight: 'bold',
        textAlign: 'center',
        fontSize: '16px'
    },
    financeOptions: {
        fontSize: 12,
        width: 240,
    },
    lblFinanceOptions: {
        width: 240,
    },
    SelectItems: {
        fontSize: 12,
    },
    costinput: {
        paddingBottom: 0,
        fontSize: 12,
    },
    margin: {
        margin: theme.spacing(1),
        paddingBottom: 0,
    },
    financeTerm: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 120,    
        fontSize: 12
    },
    maintenanceOption: {
        margin: theme.spacing(1),
        paddingBottom: 0,
        width: 200,    
        fontSize: 12
        
    },
    wosButton: {
        borderWidth: 1,
        backgroundColor: '#ffffff',
        fontSize: 12,
        paddingTop: 5,
        paddingBottom:5
    
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
});

const NF = (props) => {
    const cur = props.cur
    if(props.value == '') {
        return cur ? cur : '';
    }
    
    return (
        <NumberFormat  value={props.value} 
        displayType={'text'} 
        thousandSeparator={true} 
        decimalSeparator={'.'}
        decimalScale={2}
        fixedDecimalScale={true}
        prefix={cur ? cur : ''}  />
    )
}

const CalcResultsDetailsTables = (props) => {
    const { classes, state } = props;
    const {has_voltageoptimser, has_iboost, has_smart_thermostat, currency, savings, totals, selectedFinanceTerm} = state
    let has_finance = typeof state.financeoption !== "undefined" ? true : false
    try {
        if(state.financeoption.uid == 0)
            has_finance = false
    }catch(err) { has_finance = false}
    const has_smart_energy = false
    //console.log("CalcResultsDetailsTables savings")
    //console.log(savings )
    let average_monthly_loan = savings[0].annual_loan_cost/12
    return (
        <>
        <Typography className={classes.style30years} >{state.calcterm} Year Earnings & Savings</Typography>
        <TableContainer component={Paper} className={classes.table2}>
            <Table  stickyHeader size="small" aria-label="a dense table"  >
            <TableHead>
                <TableRow size="small" >
                    <TableCell className={classes.savingsHeaders}>Year</TableCell>
                    <TableCell className={classes.savingsHeaders}>Energy Cost</TableCell>
                    <TableCell className={classes.savingsHeaders}>Battery &amp; Solar<br/>Savings</TableCell>
                    <TableCell className={classes.savingsHeaders}>Battery &amp; Solar<br/>Savings (capped)</TableCell>
                    <TableCell className={classes.savingsHeaders}>SMART Export<br/>Benefit</TableCell>
                    {has_voltageoptimser && <TableCell className={classes.savingsHeaders}>Voltage<br/>Optimiser</TableCell> }
                    {has_iboost && <TableCell className={classes.savingsHeaders}>iBOOST</TableCell> }
                    {has_smart_thermostat && <TableCell className={classes.savingsHeaders}>SMART<br/>Thermostat</TableCell> }
                    {has_smart_energy && <TableCell className={classes.savingsHeaders}>**SMART Energy<br/>Tariff Benefit</TableCell> }
                    <TableCell className={classes.savingsHeaders}>Accumulative<br/>Savings</TableCell> 
                    <TableCell className={classes.savingsHeaders}>Accumulative<br/>Savings<br/>(capped)</TableCell> 
                    <TableCell className={classes.savingsHeaders}>%</TableCell> 
                    <TableCell className={classes.savingsHeaders}>%<br/>(capped)</TableCell> 
                    {has_finance && <TableCell className={classes.savingsHeaders}>Annual<br/>Loan<br/>Cost</TableCell> }
                    {has_finance && <TableCell className={classes.savingsHeaders}>Average<br/>Monthly<br/>Loan Cost</TableCell>}
                    <TableCell className={classes.savingsHeaders}>Your Average<br/>Monthly<br/>Savings<br/></TableCell> 
                    <TableCell className={classes.savingsHeaders}>Your Average<br/>Annual ROI%</TableCell>         

                  </TableRow>
                </TableHead>
                <TableBody  >
                    {savings.map((item,index) => {
                        var monthly = ((item.annual_loan_cost??0) / 12).toFixed(2) 
                        return (
                    <TableRow key={item.year} size="small" selected={item.breakeven}  className={classes.text30} >
                        <TableCell className={classes.text30} >{item.year}</TableCell>
                        <TableCell className={classes.text30} ><NF value={item.energy_cost} cur={currency} /></TableCell>
                        <TableCell className={classes.text30} ><NF value={(item.solar_money_savings + item.battery_money_savings)} cur={currency} /></TableCell>
                        <TableCell className={classes.text30} ><NF value={item.solar_and_battery_capped_money} cur={currency} /></TableCell>
                        <TableCell className={classes.text30} ><NF value={item.capped_smart_export_money} cur={currency} /></TableCell>
                        {has_voltageoptimser && <TableCell className={classes.text30} ><NF value={item.vo_money_savings} cur={currency} /></TableCell> }
                        {has_iboost && <TableCell className={classes.text30} ><NF value={item.iboost_savings_money} cur={currency} /></TableCell> }
                        {has_smart_thermostat && <TableCell className={classes.text30} ><NF value={item.smartthermostat_savings_money} cur={currency} /></TableCell> }
                        {has_smart_energy && <TableCell className={classes.text30} ><NF value={item.se_savings} cur={currency} /></TableCell> }
                        <TableCell className={classes.text30} ><NF value={item.accumulative_savings} cur={currency} /></TableCell>
                        <TableCell className={classes.text30} ><NF value={item.capped_accumulative_savings} cur={currency} /></TableCell>
                        <TableCell className={classes.text_small} >{item.accumulative_savings_percent}</TableCell>
                        <TableCell className={classes.text_small} >{item.capped_accumulative_savings_percent}</TableCell>
                        {has_finance && <TableCell className={classes.text30} ><NF value={item.annual_loan_cost >0 ? item.annual_loan_cost : ''} cur={currency} /></TableCell> }
                        {has_finance && <TableCell className={classes.text30} ><NF value={monthly } cur={currency} /></TableCell>}
                        <TableCell className={classes.text30} ><NF value={item.capped_accumulative_savings/12} cur={currency} /></TableCell> 
                        <TableCell className={classes.text30} ><NF value={item.annual_roi} cur={''} /></TableCell>
                    </TableRow>)})}
                    <TableRow ksize="small"  className={classes.text30} >
                        <TableCell className={classes.text30} >Totals</TableCell>
                        <TableCell className={classes.text30} ><NF value={totals.tot_energy_cost} cur={currency} /></TableCell>
                        <TableCell className={classes.text30} ><NF value={totals.tot_solar_battery_money_savings } cur={currency} /></TableCell>
                        <TableCell className={classes.text30} ><NF value={totals.tot_solar_and_battery_capped_money} cur={currency} /></TableCell>
                        <TableCell className={classes.text30} ><NF value={totals.tot_smart_export_money} cur={currency} /></TableCell>
                        {has_voltageoptimser && <TableCell className={classes.text30} ><NF value={totals.tot_vo_money_savings} cur={currency} /></TableCell> }
                        {has_iboost && <TableCell className={classes.text30} ><NF value={totals.tot_iboost_savings_money} cur={currency} /></TableCell> }
                        {has_smart_thermostat && <TableCell className={classes.text30} ><NF value={totals.tot_smartthermostat_savings_money} cur={currency} /></TableCell> }
                        {has_smart_energy && <TableCell className={classes.text30} ><NF value={totals.tot_se_savings} cur={currency} /></TableCell> }
                        <TableCell className={classes.text30} ><NF value={totals.tot_accumulative_savings} cur={currency} /></TableCell>
                        <TableCell className={classes.text30} ><NF value={totals.tot_capped_accumulative_savings} cur={currency} /></TableCell>
                        <TableCell className={classes.text_small} >{totals.perc_saved}%</TableCell>
                        <TableCell className={classes.text_small} >{totals.perc_capped_saved}%</TableCell>
                        {has_finance && <TableCell className={classes.text30} ><NF value={totals.tot_annual_loan_cost >0 ? totals.tot_annual_loan_cost : ''} cur={currency} /></TableCell> }
                        {has_finance && <TableCell className={classes.text30} ><NF value={average_monthly_loan } cur={currency} /></TableCell>}
                        <TableCell className={classes.text30} ><NF value={totals.tot_capped_accumulative_savings/savings.length/12} cur={currency} /></TableCell> 
                        <TableCell className={classes.text30} ><NF value={totals.total_roi} cur={''} />%</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
        </>
)
}


export default withStyles(styles, { withTheme: true })(CalcResultsDetailsTables)